<template>
    <div class="rank-item">
      <slot name="rank-number"></slot>
      <slot name="product-name"></slot>
      <slot name="icon"></slot>
    </div>
</template>

<script>
export default {
  name: 'rankItem',
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.rank-item{
  height: 36px;
}
</style>
